import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const UploadIcon = ({ color = '#B5BCBD', size = 20, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 16 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M5.031 5.718L6.818 3.9v8.025c0 .637.497 1.144 1.124 1.144.626 0 1.124-.506 1.124-1.144V3.88l1.786 1.818c.221.225.498.338.793.338.295 0 .57-.113.792-.338a1.147 1.147 0 0 0 0-1.612L8.734.337a1.1 1.1 0 0 0-1.585 0L3.447 4.106a1.147 1.147 0 0 0 0 1.612c.442.45 1.142.45 1.584 0z" />
      <path d="M14.61 11.306c-.626 0-1.124.506-1.124 1.144v3.094l-11.107-.001v-3.094c0-.637-.498-1.144-1.124-1.144-.626 0-1.124.506-1.124 1.144v4.238c0 .637.497 1.144 1.124 1.144H14.61c.626 0 1.124-.506 1.124-1.144V12.45c0-.637-.497-1.143-1.124-1.143z" />
    </g>
  </svg>
);

UploadIcon.propTypes = propTypes;

export default UploadIcon;
